export const cleanPhoneNumber = (phoneNumber: string): string => {
  return phoneNumber.replace(/[^+\d]+/g, '');
};
